import * as React from "react";
import {Component} from "react";
import styles from "../styles/wizards/AddSiteWizard.scss";
import autobind from "autobind-decorator";
import AddSiteIcon from "../assets/images/add-site-60x60.svg";
import {__, mapStateToProps, setTableParams, validateForm} from "../core/utils";
import {withRouter} from "react-router";
import {getStagesLanguages} from "../redux/actions/table/stages";
import AddSiteForm from "../forms/add_site_wizard/AddSiteForm";
import {setNotification} from "../redux/actions/general/notification";
import {createSite, listSites} from "../redux/actions/table/sites";

@withRouter
@mapStateToProps(state => ({
	table: state.table["sites"],
}))
class AddSiteWizard extends Component {
	constructor(props) {
		super(props);

		this.state = {
			project_languages: null
		}
	}

	componentDidMount() {
		getStagesLanguages(this.props.match.params.stage).then(({response}) => {
			this.setState({project_languages: response.data});
		});
	}

	@autobind
	_handleSubmit(formData) {
		const {edit} = formData;

		formData = _.omit(formData, ['edit']);

		return validateForm(
			createSite(this.props.match.params.stage, formData).then(({response}) => {
				listSites(this.props.match.params.stage).then(() => {
					if(edit) {
						setTableParams('sites', {
							clicked_row: response.data.id
						});
					}
				});

				setTableParams('sites', {
					actioned_row: undefined,
					selected_rows: []
				});

				this.props.onClose();

				setNotification(__("wizard.add-site.message.success"));
			})
		);
	}

	render() {
		return (
			<>
				<div className={styles.header}>
					<div className={styles.left}>
						<span>{__('wizard.add-site.title.add-new-site')}</span>
						<span>{__('wizard.add-site.subtitle.add-new-site')}</span>
					</div>
					<div className={styles.right}>
						<AddSiteIcon />
					</div>
				</div>
				<div className={styles.body}>
					{this.state.project_languages && <AddSiteForm
						projectLanguages={this.state.project_languages}
						onSubmit={this._handleSubmit}
						initialValues={{
							title: {},
							description: {},
						}}
					/>}
				</div>
			</>
		);
	}
}

export default AddSiteWizard;